import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { firebase } from '../firebase';

import fcmInstancesApi from '../api/fcmInstancesApi';

const withMessaging = (Component) => {
  class WithMessaging extends React.Component {
    componentDidMount() {
		var authToken = this.context.authToken;
		
	    // Callback fired if Instance ID token is updated.
	    firebase.messaging.onTokenRefresh(function() {
	      firebase.messaging.getToken()
	      .then(function(refreshedToken) {
	        // Indicate that the new Instance ID token has not yet been sent to the
	        // app server.
	        setTokenSentToServer(false);

	        // Display new Instance ID token and clear UI of all previous messages.
	        getToken(authToken);
	      })
	      .catch(function(err) {
	        console.log('Unable to retrieve refreshed token ', err);
	      });
	    });
		
		var store = this.context.store;
		
	    // Handle incoming messages. Called when:
	    // - a message is received while the app has focus
	    // - the user clicks on an app notification created by a sevice worker
	    //   `messaging.setBackgroundMessageHandler` handler.
	    firebase.messaging.onMessage(function(payload) {
	      console.log(payload);
		  
		  if (payload && payload.data && payload.data.app && payload.data.version && payload.data.version == '1') {
			  var data = payload.data;
			  switch (data.app) {
			  case 'SenseEV':
				  if (data.type) {
					  switch (data.type) {
					  default:
						  console.log('Unrecognized type: ' + data.type)
					  }
				  } else {
					  console.log('Missing type');
				  }
				  break;
				  
			  default:
				  console.log('Unrecognized app: ' + payload.data.app)
			  }
		  } else {
			  console.log('Unrecognized app and version: ' + data.app + ' / ' + data.version);
		  }
	    });
		
	    getToken(authToken);
    }

    render() {
		return (
			<Component {...this.props}/>
		);
    }
  }

  WithMessaging.contextTypes = {
	authToken: PropTypes.string.isRequired,
	store: PropTypes.object.isRequired
  };

  return WithMessaging;
}

function getToken(authToken) {
  // Get Instance ID token. Initially this makes a network call, once retrieved
  // subsequent calls to getToken will return from cache.
  firebase.messaging.getToken()
  .then(function(currentToken) {
      if (currentToken) {
        sendTokenToServer(currentToken, authToken);
      } else {
        setTokenSentToServer(false);
  
        // Show permission request.
	    if (confirm('Would you like to see updates automatically?')) {
		  requestPermission(authToken);
	    }
      }
  })
  .catch(function(err) {
    console.log('An error occurred while retrieving token. ', err);
    setTokenSentToServer(false);
  });
}

// Send the Instance ID token your application server, so that it can:
// - send messages back to this app
// - subscribe/unsubscribe the token from topics
function sendTokenToServer(currentToken, authToken) {
  if (!isTokenSentToServer()) {
	fcmInstancesApi.subscribe('deviceId', authToken, currentToken);

    setTokenSentToServer(true);
  } else {
	  // Nothing to do
  }

}

function isTokenSentToServer() {
  return window.localStorage.getItem('sentToServer') == 1;
}

function setTokenSentToServer(sent) {
  window.localStorage.setItem('sentToServer', sent ? 1 : 0);
}

function requestPermission(authToken) {
  firebase.messaging.requestPermission()
  .then(function() {
	  getToken(authToken);
  })
  .catch(function(err) {
    console.log('Unable to get permission to notify.', err);
  });
}

function deleteToken(authToken) {
  // Delete Instance ID token.
  // [START delete_token]
  firebase.messaging.getToken()
  .then(function(currentToken) {
  	fcmInstancesApi.unsubscribe('deviceId', authToken, currentToken);

    messaging.deleteToken(currentToken)
    .then(function() {
      console.log('Token deleted.');
      setTokenSentToServer(false);
      // [START_EXCLUDE]
      // Once token is deleted update UI.
      getToken(authToken);
      // [END_EXCLUDE]
    })
    .catch(function(err) {
      console.log('Unable to delete token. ', err);
    });
    // [END delete_token]
  })
  .catch(function(err) {
    console.log('Error retrieving Instance ID token. ', err);
  });
}

export default withMessaging;


// WEBPACK FOOTER //
// ./src/components/withMessaging.js